import { ReactElement, useCallback } from 'react';

import { Skeleton } from '@beeline/design-system-react/extracted-styles';

import { ErrorElement } from '../ErrorElement';
import { GridItem } from '../GridItem';

import { WidgetInjected } from ':components/Widgets/Widget/WidgetInjected';
import { WidgetsData } from ':types';

type SubGridItemProps = Omit<WidgetsData, 'id' | 'container'>;

export function SubGridItem({
  name,
  host,
  size_small,
  size_medium,
  size_large,
  email,
  skeleton: SkeletonComponent,
}: SubGridItemProps): ReactElement {
  const fallback = SkeletonComponent ? (
    <SkeletonComponent />
  ) : (
    <Skeleton radius={12} height={size_large.y} />
  );
  const errorElement = useCallback(
    (message: string | boolean) => (
      <ErrorElement message={message} email={email} />
    ),
    [email]
  );

  const widget = (
    <WidgetInjected
      name={name}
      host={host}
      fallback={fallback}
      errorElement={errorElement}
    />
  );

  return (
    <GridItem lg={size_large.x} md={size_medium.x} sm={size_small.x}>
      {widget}
    </GridItem>
  );
}
